/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface T2ConfigDto {
  accessKey?: string;
  adapterMAC?: string;
  adapterSerial?: string;
  locationId?: number;
  locationType?: string;
  machineId?: number;
  machineMake?: string;
  machineType?: string;
  ownerId?: number;
  ownerUsername?: string;
}
